import { render, staticRenderFns } from "./LeadHistory.vue?vue&type=template&id=19a6fbc2&scoped=true"
import script from "./LeadHistory.vue?vue&type=script&lang=js"
export * from "./LeadHistory.vue?vue&type=script&lang=js"
import style0 from "./LeadHistory.vue?vue&type=style&index=0&id=19a6fbc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6fbc2",
  null
  
)

export default component.exports